import { FC } from 'react';
import { IRTERenderElementProps } from '../../../../RTEEditable.interfaces';
import { getJsxStyles } from '../../../../utils/RTEEditable.utils';

export const ParagraphElement: FC<IRTERenderElementProps> = (props) => {
  const { element, children } = props;
  const attributes = props.attributes ?? {};

  return (
    <p
      {...element.attr}
      {...attributes}
      style={{
        margin: 0,
        minHeight: '18px',
        ...element?.styles,
        ...getJsxStyles(element?.style?.value),
      }}
    >
      {children}
    </p>
  );
};
